import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Box, DialogContent } from '@material-ui/core';
import Modal from '../../../_ui/Modal/Modal';
import { createOrder } from '../ComparePhotoDucks';
import Button from '@material-ui/core/Button';
import useTree from '../../../components/TableFilter/ColumnsFilters/FilterTreeSelect/useTree';
import TreeSelect from '../../../_ui/TreeSelect/TreeSelect';
import { TreeSelectWrapper, TableWrapper } from './CreateOrderModalStyles';
import useColumnFilter from '../../../components/TableFilter/useColumnFilter';
import SchoolListTable from './SchoolListTable';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

export default function CreateOrderModal({ close }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { value, setFilter } = useColumnFilter('extraFilters');
  const [isFirst, setIsFirst] = useState(false);
  const [selectedDdo, setSelectedDdo] = useState('');
  const lookupId = 60;
  const FILTER_CODE = '';
  const parsedValue = JSON.parse(value) || {};

  const { tree, onExpand, loadingArr } = useTree({
    lookupId: lookupId,
    filterCode: FILTER_CODE,
    value: parsedValue['locationCode'] === FILTER_CODE ? '' : parsedValue['locationCode']
  });

  const handleAdd = () => {
    dispatch(createOrder(selectedDdo.id, isFirst, close));
  };
  const toggleIsFirst = () => {
    setIsFirst(prevState => !prevState);
  };
  const onClickRow = ({ original }) => {
    setSelectedDdo(original);
  };

  return (
    <Modal
      maxWidth="lg"
      title={t('comparePhoto_modalCreateTitle')}
      open
      onClose={close}
      scroll="paper"
    >
      <DialogContent dividers>
        <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
          <TreeSelectWrapper>
            <span>{t('serviceProviders_columnLocation')}</span>
            <TreeSelect
              lookupId={lookupId}
              loadingArr={loadingArr}
              onExpand={onExpand}
              data={tree}
              withoutForm
              fullWidth
              onChange={v =>
                setFilter(
                  JSON.stringify({
                    ...parsedValue,
                    locationCode: v
                  })
                )
              }
              value={parsedValue['locationCode']}
            />
          </TreeSelectWrapper>
          <FormControlLabel
            control={
              <Checkbox
                checked={isFirst}
                onChange={toggleIsFirst}
                color="primary"
                disabled={!selectedDdo}
              />
            }
            label={t('comparePhoto_addToTop')}
            style={{ marginBottom: '16px' }}
          />
        </Box>

        <TableWrapper>
          <SchoolListTable index={1} onClickRow={onClickRow} selectedDdo={selectedDdo} />
        </TableWrapper>

        <div className="flex justify-end" style={{ marginTop: '16px' }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleAdd}
            disabled={!selectedDdo}
          >
            {t('comparePhoto_add')}
          </Button>
        </div>
      </DialogContent>
    </Modal>
  );
}
